import React, { useState } from 'react';
import { AddedAttribute, AddedAttributeType, AddedSection } from 'pages/UserPage/components/MiddlePane/types';
import { IMAGE_FILE_REGEX } from 'common/constants/constants';
import { updateAddedValue, updateValue } from '../../../updateAttributeValueUtils';
import FileUpload from './FileUpload';

interface Props {
  addedSections: AddedSection[];
  attributeType: AddedAttributeType;
  isImage?: boolean;
  section: AddedSection;
  setAddedSections: (addedSections: AddedSection[]) => void;
  setUserAttributeTypes: (userAttributeTypes: AddedAttributeType[]) => void;
  userAttributeTypes: AddedAttributeType[];
}

const FileEditField = ({
  addedSections,
  attributeType,
  isImage,
  section,
  setAddedSections,
  setUserAttributeTypes,
  userAttributeTypes,
}: Props) => {
  const [values, setValues] = useState<string[]>(attributeType.attributes.map(attribute => attribute.value as string));

  const updateAttributes = (newValues: string[]) => {
    if (section.addedSection) {
      updateAddedValue(
        section.name,
        attributeType.name,
        newValues,
        addedSections,
        userAttributeTypes,
        setUserAttributeTypes,
        setAddedSections
      );
    } else {
      const attrs: AddedAttribute[] = newValues.map(value => ({ value }));
      updateValue(attributeType.name, attrs, userAttributeTypes, setUserAttributeTypes);
    }
  };

  const onUpload = (uuid: string, filename: string) => {
    const newValues = attributeType.singleton
      ? [JSON.stringify({ uuid, filename })]
      : [...values, JSON.stringify({ uuid, filename })];
    setValues(newValues);
    updateAttributes(newValues);
  };

  const onRemove = (removeInd: number) => {
    const newValues = values.filter((value, i) => i !== removeInd);
    setValues(newValues);
    updateAttributes(newValues);
  };

  return (
    <FileUpload
      checkFileType={file => !isImage || !!file.type.match(IMAGE_FILE_REGEX)}
      fileAttributes={attributeType.attributes}
      isImage={isImage}
      onRemove={onRemove}
      onUpload={onUpload}
      singleton={attributeType.singleton}
    />
  );
};

export default FileEditField;
